"use strict";

export default {
    _handleItemMouseout(e) {
        $(e.currentTarget).removeClass("cbp-hropen");
    },

    _handleItemMouseover(e) {
        $(e.currentTarget).addClass("cbp-hropen");
    },

    init() {
        $(document).on(
            "mouseout",
            "#cbp-hrmenu .cbp-hrmenu-main-item",
            this._handleItemMouseout.bind(this)
        );

        $(document).on(
            "mouseover",
            "#cbp-hrmenu .cbp-hrmenu-main-item",
            this._handleItemMouseover.bind(this)
        );
    },
};
